import React, { useEffect } from "react";
import LoginForm from "./LoginForm";
import styled from "styled-components";
import CarouselSlider from "./CarouselSlider";
import { useState } from "react";
import Blocker from "../Blocker/Blocker";
import NotifyBanner from "../Notification/NotifyBanner";
import { getURLValue } from "../Common";

export const Wraped = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  background-color: #fff;
  height: 100vh;
  margin-top: 75px;

  @media screen and (max-width: 767px) {
    grid-template-rows: 1fr 1fr;
    grid-template-columns: auto;
    height: 124vh;
    margin-top: 115px;
  }
  @media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
    /* height: 145vh; */
    height: 120vh;
    margin-top: 78px;
  }
`;

export default function LogInPage({ hasSession }) {
  const [isLoading, setIsLoading] = useState(false);
  const [successBanner, setSuccessBanner] = useState(false);
  const [bannerMessage, setBannerMessage] = useState("");

  //guest login
  const [isGuest, setIsGuest] = useState(false);
  const [showSection, setShowSection] = useState("login");

  useEffect(() => {
    if (typeof window === "undefined") return;

    const domainMap = {
      development: "ideastage.in",
      stage: "ideastage.in",
      qa: "ideaqa.in",
      production: "ideapoke.com",
    };

    const env = process.env.NEXT_PUBLIC_SERVER || "production";
    const mainDomain = domainMap[env] || "ideapoke.com";

    let hostname = window.location.hostname;
    console.log("hostname:", hostname);

    //Normalize hostname to ignore 'www.'
    const normalizedHostname = hostname.startsWith("www.")
      ? hostname.slice(4)
      : hostname;

    if (process.env.NODE_ENV === "development") {
      console.log("🔍 Normalized hostname:", normalizedHostname);
      console.log("→ Main domain:", mainDomain);
    }

    if (normalizedHostname === mainDomain) return;

    if (normalizedHostname.endsWith("." + mainDomain)) {
      const protocol = window.location.protocol;
      const path = window.location.pathname;
      const search = window.location.search;
      const newUrl = `${protocol}//${mainDomain}${path}${search}`;

      if (process.env.NODE_ENV === "development") {
        console.log("🚀 Redirecting to main domain:", newUrl);
      }

      window.location.replace(newUrl);
    }
  }, []);

  useEffect(() => {
    const urlTemp = getURLValue("temp");

    if (urlTemp == "verifiedsuccess") {
      setBannerMessage(
        "Your email address has been verified. Please login to access your Ideapoke account."
      );
      setSuccessBanner(true);
    }
    if (urlTemp == "donereset") {
      setBannerMessage(
        "Your password has been reset successfully. Please login to access your Ideapoke account."
      );
      setSuccessBanner(true);
    }
  }, []);

  useEffect(() => {
    const value = getURLValue("key");
    if (value && value == "GUESTLOGIN") {
      setShowSection("guest");
      setIsGuest(true);
    }
  }, []);

  return (
    <div>
      {isLoading && <Blocker />}
      {successBanner && (
        <NotifyBanner
          setSuccessBanner={setSuccessBanner}
          successBanner={successBanner}
          BackColor="#D4FFDE"
          color="#1F936E"
          Notify={bannerMessage}
        />
      )}
      <Wraped>
        <div style={{ width: "100%", position: "relative" }}>
          <CarouselSlider />
        </div>

        <div>
          <LoginForm
            setIsLoading={setIsLoading}
            isGuest={isGuest}
            showSection={showSection}
            setShowSection={setShowSection}
            hasSession={hasSession}
          ></LoginForm>
        </div>
      </Wraped>
    </div>
  );
}
